<template>
    <div>
        <div v-if="!roleLoading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Edit Role</h4>
                    <p class="text-subtitle-1">modify role</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <RoleForm
                        v-model="data"
                        v-if="!roleLoading"
                    ></RoleForm>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn 
                        color="primary"
                        block 
                        @click="handleSave"
                        :loading="updateLoading"      
                    >
                    Save</v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn 
                        block 
                        depressed
                        @click="handleCancel"
                    >
                        cancel
                    </v-btn>
                </v-col>
            </v-row>
        </div>
       <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
        </div>
        
        <PAlert v-model="alert.value" v-bind="alert"></PAlert>
    </div>
</template>

<script>
import PAlert from "./../../components/common/PAlert.vue"
import RoleForm from "./../../components/administration/RoleForm.vue"
import role from "./../../services/administration/role"
import { mapActions } from 'vuex'
export default {
    components: {
        RoleForm,
        PAlert
    },
    data() {
        return {
            data: {},
            id: null,
            roleLoading: false,
            updateLoading: false,
             alert:{
                title: "Alert",
                value: false,
                content: "",
                callback: null
            }
        }
    },
    methods: {
        ...mapActions({
           snackbar: "ui/snackbar/show"
        }),
        fetchRole(id) {
            this.roleLoading = true
            role.get(id).then(response => [
                this.data = response.data 
            ]).finally(() => {
                this.roleLoading = false
            })
        },
        handleSave() {
            this.alert = { 
                ...this.alert , 
                value : true,
                content: "Are you sure you want to save?",
                callback: this.submit
            }
        },
        submit() {
            this.updateLoading = true
            role.update(this.data).then(response => {
                if(response.data?.record?.id){
                    this.snackbar({
                        text: response.data.message,
                        color: "success"
                    })  
                    this.$router.replace({ name:"RoleDisplay", params:{ id :response?.data?.record?.id } })
                }else {
                    let text = Object.values(response.data).join()
                    this.snackbar({
                        text,
                        color: "error"
                    })
                }
            }).finally(() => this.updateLoading = false )
            
        },
        handleCancel() {
            this.alert = { 
                ...this.alert , 
                value : true,
                content: "Are you sure you want to Cancel?",
                callback: this.cancel
            }            
        },
        
        cancel() {
            this.$router.back()
        }
    },  
    created() {
        this.id = this.$route.params.id
        this.fetchRole(this.id)
    }
}
</script>

<style>

</style>